import {
  ITitlePageBlock,
  useBlocksActions,
} from '@/models/commercial-proposals/blocks.store';
import { useProposal } from '@/models/commercial-proposals/proposal.store';
import {
  Box,
  Divider,
  Flex,
  Group,
  Image,
  InputDescription,
  InputLabel,
  Stack,
  TextInput,
} from '@mantine/core';
import { PiCoins, PiHandshake, PiLeaf, PiStrategy } from 'react-icons/pi';
import BlockBase from './BlockBase';

export default function TitlePageBlock({
  block,
  index,
}: {
  block: ITitlePageBlock;
  index: number;
}) {
  const { update } = useBlocksActions();
  const proposal = useProposal();
  const {
    jurisdiction = proposal?.jurisdiction,
    documentTitle = proposal?.name,
    subtitle,
    list = [],
  } = block.config;

  return (
    <BlockBase block={block} index={index} settings={null}>
      <Box mt="xs">
        <Group justify="space-between" mb="xs">
          <Box>
            <InputLabel size="xs">Jurisdiction</InputLabel>
            <InputDescription size="xs">
              The flag displayed on the title page is based on the jurisdiction
              of the commercial proposal.
            </InputDescription>
          </Box>
          <Image
            src={`/static/flags/${jurisdiction?.toLowerCase()}.svg`}
            alt={jurisdiction}
            radius="xs"
            w="auto"
            h="32px"
            style={{ border: '1px solid var(--mantine-color-gray-4)' }}
          />
        </Group>
        <Divider />
        <TextInput
          size="xs"
          label="Title"
          value={documentTitle}
          onChange={(e) => {
            update({
              ...block,
              config: { ...block.config, documentTitle: e.target.value },
            });
          }}
        />
        <TextInput
          size="xs"
          label="Subtitle"
          value={subtitle}
          onChange={(e) => {
            update({
              ...block,
              config: { ...block.config, subtitle: e.target.value },
            });
          }}
        />
        <Divider my="xs" />
        <Box>
          <InputLabel size="xs" mb="xs">
            List Items
          </InputLabel>
          <Stack gap="xs">
            {(
              [PiStrategy, PiCoins, PiLeaf, PiHandshake] as React.ElementType[]
            ).map((Icon, i) => (
              <Flex key={i} direction="row" gap="sm" align="center" ms="xs">
                <Icon size={20} />
                <TextInput
                  size="xs"
                  placeholder={`Item ${i + 1}`}
                  maw="450"
                  w="100%"
                  value={list[i] ?? ''}
                  onChange={(e) => {
                    update({
                      ...block,
                      config: {
                        ...block.config,
                        list: ((list[i] = e.target.value), list),
                      },
                    });
                  }}
                />
              </Flex>
            ))}
          </Stack>
        </Box>
      </Box>
    </BlockBase>
  );
}
